/**
 * Derive how a match should look in challenge / history UI when API status lags behind kickoff.
 * Does not change server or list bucketing — display only.
 */

const TERMINAL_STATUSES = new Set(['FINISHED', 'CANCELLED', 'POSTPONED', 'ABANDONED']);

/**
 * Uppercase display status: LIVE / IN_PLAY / FINISHED / …
 * When kickoff is in the past and the match is not terminal, treat as LIVE so rows show in-play styling.
 */
export function getMatchDisplayStatusUpper(rawStatus: unknown, kickoff: string | Date | undefined | null): string {
  const u = String(rawStatus ?? '').trim().toUpperCase();
  if (!kickoff) {
    return u || 'UPCOMING';
  }
  const t = new Date(kickoff).getTime();
  const kickoffPassed = Number.isFinite(t) && t <= Date.now();
  if (TERMINAL_STATUSES.has(u)) {
    return u;
  }
  if (u === 'LIVE' || u === 'IN_PLAY') {
    return u;
  }
  if (kickoffPassed) {
    return 'LIVE';
  }
  return u || 'UPCOMING';
}
